import { render } from "./ObjectDelete.vue?vue&type=template&id=b6e9d5d2"
import script from "./ObjectDelete.vue?vue&type=script&lang=js"
export * from "./ObjectDelete.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.12.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__